import { useColorScheme } from "@mui/material";

export function useAppLogo() {
  const { mode, systemMode } = useColorScheme();
  const resolvedMode = systemMode || mode;

  return resolvedMode === "dark" ? "/logo-dark.png" : "/logo-light.png";
}
